import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";

export default function CustomerListModal({
  isOpen,
  onClose,
  onSelect,
  onSearch,
  selectedIds = [],
  customers = [],
}) {
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(selectedIds);

  useEffect(() => {
    if (isOpen) {
      setSelected(selectedIds);
      setSearch("");
    }
  }, [isOpen, selectedIds]);

  if (!isOpen) return null;

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const toggleSelectAll = () => {
    const ids = customers.map((c) => c.AR_Id);
    if (ids.every((id) => selected.includes(id))) {
      setSelected(selected.filter((id) => !ids.includes(id)));
    } else {
      setSelected([...new Set([...selected, ...ids])]);
    }
  };

  const handleSearchClick = () => {
    if (onSearch) {
      onSearch({ keyword: search });
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center"
      style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
    >
      <div className="bg-white rounded-xl shadow-lg w-full max-w-4xl overflow-hidden">
        {/* Header */}
        <div
          className="flex items-center gap-2 px-4 py-3 text-white"
          style={{ background: "#E13F57" }}
        >
          <Icon icon="mdi:account-group" className="w-5 h-5" />
          <h2 className="font-bold flex-1">รายชื่อลูกค้า</h2>
          <button onClick={onClose} className="hover:text-gray-200 text-lg">
            ✕
          </button>
        </div>

        {/* Search */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSearchClick();
          }}
          className="flex items-center gap-2 px-4 py-3 border-b bg-gray-50"
        >
          <input
            type="text"
            placeholder="ค้นหา รหัส/ชื่อลูกค้า"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border rounded-full px-3 h-[32px] w-[400px] outline-none"
            style={{ focusRingColor: "#E13F57" }}
          />
          {/* ปุ่มค้นหา */}
          <button
            type="submit"
            className="
              flex items-center justify-center gap-[5px]
              w-[90px] h-[30px] px-[12px] py-[7px]
              rounded-[19.5px] border border-[#4665CB] bg-[#4665CB]
              text-white/90 text-[14px] font-semibold font-[Open_Sans]
              hover:opacity-90 transition
            "
          >
            <img
              src="/assets/img/icon/circum_search.svg"
              alt="search"
              className="w-[18px] h-[18px] shrink-0"
            />
            ค้นหา
          </button>
        </form>

        {/* Table */}
        <div className="p-4 max-h-[400px] overflow-y-auto">
          <div className="rounded-lg overflow-hidden shadow border border-gray-200">
            <table className="w-full text-sm border-collapse">
              <thead>
                <tr style={{ background: "#E13F57" }} className="text-white">
                  <th className="px-3 py-2 text-center w-[40px]">
                    <input
                      type="checkbox"
                      onChange={toggleSelectAll}
                      checked={
                        customers.length > 0 &&
                        customers.every((c) => selected.includes(c.AR_Id))
                      }
                    />
                  </th>
                  <th className="px-3 py-2">รหัสลูกค้า</th>
                  <th className="px-3 py-2">ชื่อลูกค้า</th>
                  <th className="px-3 py-2">เบอร์โทร</th>
                </tr>
              </thead>
              <tbody>
                {customers.length > 0 ? (
                  customers.map((c, idx) => (
                    <tr
                      key={c.AR_Id}
                      className={`${
                        idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                      } hover:bg-gray-100`}
                    >
                      <td className="px-3 py-2 text-center">
                        <input
                          type="checkbox"
                          checked={selected.includes(c.AR_Id)}
                          onChange={() => toggleSelect(c.AR_Id)}
                        />
                      </td>
                      <td className="px-3 py-2 text-center">
                        {c.AR_Code || "-"}
                      </td>
                      <td className="px-3 py-2">
                        {c.AR_Name || ""} {c.AR_LastName || ""}
                      </td>
                      <td className="px-3 py-2">{c.AR_Tel || "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      className="text-center py-4 text-gray-500"
                    >
                      ไม่พบข้อมูล
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 px-4 py-3 border-t bg-gray-50">
            <button
                onClick={() => setSelected([])} //  ล้างการเลือก
                className="bg-white text-gray-600 hover:bg-gray-100 px-6 py-2 rounded-lg border"
            >
                ล้างการเลือก
            </button>

            <button
                onClick={onClose}
                className="bg-white text-[#E13F57] hover:bg-red-50 px-6 py-2 rounded-lg border"
                style={{ borderColor: "#E13F57" }}
            >
                ยกเลิก
            </button>

            <button
                onClick={() => {
                const selectedObjects = customers.filter((c) =>
                    selected.includes(c.AR_Id)
                );
                onSelect(selectedObjects);
                onClose();
                }}
                className="px-6 py-2 rounded-lg shadow text-white hover:opacity-90"
                style={{ background: "#E13F57" }}
            >
                เลือก
            </button>
        </div>
      </div>
    </div>
  );
}
